import { ComponentProps, forwardRef } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';

import { spacerClass, tooltipArrowClass } from './TooltipArrow.css';

export { tooltipArrowSize } from './TooltipArrow.css';

export const TooltipArrow = forwardRef<HTMLDivElement, ComponentProps<'div'>>(({ className, ...props }, ref) => (
  <div ref={ref} className={getClassNames(tooltipArrowClass, className)} {...props} />
));

TooltipArrow.displayName = 'TooltipArrow';

export const Spacer = forwardRef<HTMLDivElement, ComponentProps<'div'>>(({ className, ...props }, ref) => (
  <div ref={ref} className={getClassNames(spacerClass, className)} {...props} />
));

Spacer.displayName = 'Spacer';
